import { closePopup, showPopup } from '../popup'

const initThankYouPopup = () => {
  const closePopupBtns = document.querySelectorAll('.popup-close')
  const popup = document.getElementById('thank-popup')
  const popupOverlay = document.getElementById('thank-popup-overlay')

  document.addEventListener('wpcf7mailsent', function () {
    showPopup(popup)
  }, false)

  if (closePopupBtns) {
    closePopupBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        closePopup(popup)
        location.reload()
      })
    })
  }

  if (popupOverlay) {
    popupOverlay.addEventListener('click', () => {
      popupOverlay.firstElementChild.addEventListener('click', function (e) {
        e.stopPropagation()
      })
      closePopup(popup)
    })
  }
}

export default initThankYouPopup
